<template>
  <div
      style="padding: 2px 0; display: flex; align-items: center;"
      class="flex-row"
      :class="[
        isError ? 'status-tag status-tag--error' : 'status-tag',
        disableTip ? 'status-tag--regular-cursor' : 'status-tag--help-cursor'
      ]">
    <div class="status-indicator"></div>
    <el-popover
        :disabled="disableTip"
        placement="right"
        trigger="hover">
      <span
          slot="reference"
          style="vertical-align: middle;">{{ statusMessage }}</span>
      <slot name="popover-content"></slot>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: "StatusTag",
  props: {
    statusMessage: {
      type: String,
      required: true,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    disableTip: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
$success-color: #009f29;
$error-color: #d71b00;

.status-tag {
  color: $success-color;

  .status-indicator {
    background-color: $success-color;
  }

  &--help-cursor {
    cursor: help;
  }

  &--regular-cursor {
    cursor: default;
  }

  &--error {
    width: auto;
    display: inline-block;
    color: $error-color;

    .status-indicator {
      background-color: $error-color;
    }
  }
}

.status-indicator {
  width: 10px;
  height: 10px;
  border: solid 1px transparent;
  border-radius: 100%;
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px !important;
  margin-bottom: 1px;
}
</style>
